import React from 'react'

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false
      };
    }
    componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({ hasError: true });
      // You can also log the error to an error reporting service
      // Just logging it in the console for demo purposes
      console.error(error, info);
    }
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <div className="errorBoundary">
          <div className="title">
             <h1>Opps!</h1>
            <h2>Something went wrong</h2>
            <span>Please refresh the page.</span> 
          </div>
        </div>
        );
      }
      return this.props.children;
    }
  }